export abstract class CompanyConstants {
  public static readonly NAME_MAX_LENGTH: number = 30;
}
